var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container" },
    [
      _c(
        "a-modal",
        {
          staticStyle: { top: "20px", height: "95%" },
          attrs: {
            title: _vm.title,
            width: 1200,
            visible: _vm.visible,
            getContainer: () => _vm.$refs.container,
            maskStyle: { top: "93px", left: "154px" },
            wrapClassName: _vm.wrapClassNameInfo(),
            mask: _vm.isDesktop(),
            maskClosable: false,
            cancelText: "关闭",
          },
          on: { cancel: _vm.handleCancel },
        },
        [
          _c(
            "template",
            { slot: "footer" },
            [
              _c("a-button", { key: "back", on: { click: _vm.handleCancel } }, [
                _vm._v("取消"),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "table-page-search-wrapper" },
            [
              _c(
                "a-form",
                {
                  attrs: { layout: "inline" },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.searchQuery.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { md: 8, sm: 24 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "单据编号",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                              },
                            },
                            [
                              _c("a-input", {
                                attrs: { placeholder: "请输入单据编号" },
                                model: {
                                  value: _vm.queryParam.number,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryParam, "number", $$v)
                                  },
                                  expression: "queryParam.number",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { md: 8, sm: 24 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "单据日期",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                              },
                            },
                            [
                              _c("a-range-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  format: "YYYY-MM-DD",
                                  placeholder: ["开始时间", "结束时间"],
                                },
                                on: {
                                  change: _vm.onDateChange,
                                  ok: _vm.onDateOk,
                                },
                                model: {
                                  value: _vm.queryParam.createTimeRange,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryParam,
                                      "createTimeRange",
                                      $$v
                                    )
                                  },
                                  expression: "queryParam.createTimeRange",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { md: 8, sm: 24 } },
                        [
                          _c(
                            "a-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.searchQuery },
                            },
                            [_vm._v("查询")]
                          ),
                          _c(
                            "a-button",
                            {
                              staticStyle: { "margin-left": "8px" },
                              on: { click: _vm.searchReset },
                            },
                            [_vm._v("重置")]
                          ),
                          _c(
                            "a-button",
                            {
                              staticStyle: { "margin-left": "8px" },
                              attrs: { icon: "download" },
                              on: { click: _vm.exportExcel },
                            },
                            [_vm._v("导出")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-table",
            {
              ref: "table",
              attrs: {
                bordered: "",
                size: "middle",
                rowKey: "id",
                columns: _vm.columns,
                dataSource: _vm.dataSource,
                components: _vm.handleDrag(_vm.columns),
                pagination: _vm.ipagination,
                loading: _vm.loading,
              },
              on: { change: _vm.handleTableChange },
              scopedSlots: _vm._u([
                {
                  key: "numberCustomRender",
                  fn: function (text, record) {
                    return _c("span", {}, [
                      _c(
                        "a",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.myHandleDetail(record)
                            },
                          },
                        },
                        [_vm._v(_vm._s(record.number))]
                      ),
                    ])
                  },
                },
              ]),
            },
            [
              _c(
                "span",
                { attrs: { slot: "customTitle" }, slot: "customTitle" },
                [
                  _c(
                    "a-popover",
                    { attrs: { trigger: "click", placement: "right" } },
                    [
                      _c(
                        "template",
                        { slot: "content" },
                        [
                          _c(
                            "a-checkbox-group",
                            {
                              attrs: { defaultValue: _vm.settingDataIndex },
                              on: { change: _vm.onColChange },
                              model: {
                                value: _vm.settingDataIndex,
                                callback: function ($$v) {
                                  _vm.settingDataIndex = $$v
                                },
                                expression: "settingDataIndex",
                              },
                            },
                            [
                              _c(
                                "a-row",
                                { staticStyle: { width: "600px" } },
                                [
                                  _vm._l(
                                    _vm.defColumns,
                                    function (item, index) {
                                      return [
                                        [
                                          _c(
                                            "a-col",
                                            { attrs: { span: 6 } },
                                            [
                                              item.dataIndex === "rowIndex"
                                                ? _c("a-checkbox", {
                                                    attrs: {
                                                      value: item.dataIndex,
                                                      disabled: "",
                                                    },
                                                  })
                                                : _vm._e(),
                                              item.dataIndex !== "rowIndex"
                                                ? _c(
                                                    "a-checkbox",
                                                    {
                                                      attrs: {
                                                        value: item.dataIndex,
                                                      },
                                                    },
                                                    [
                                                      _c("j-ellipsis", {
                                                        attrs: {
                                                          value: item.title,
                                                          length: 10,
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ],
                                      ]
                                    }
                                  ),
                                ],
                                2
                              ),
                              _c(
                                "a-row",
                                { staticStyle: { "padding-top": "10px" } },
                                [
                                  _c(
                                    "a-col",
                                    [
                                      _vm._v(
                                        "\n                  恢复默认列配置："
                                      ),
                                      _c(
                                        "a-button",
                                        {
                                          attrs: {
                                            type: "link",
                                            size: "small",
                                          },
                                          on: { click: _vm.handleRestDefault },
                                        },
                                        [_vm._v("恢复默认")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("a-icon", { attrs: { type: "setting" } }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ]
          ),
          _c("bill-detail", { ref: "billDetail" }),
          _c("financial-detail", { ref: "financialDetail" }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }